// import React, { useEffect, useLayoutEffect, useState } from "react";
// import { giftCard, CountryRegions, giftCardUpdate, merchantGiftCard, getSelectedGiftCard, getSelectGiftCard } from "../../../actions/auth";
// import Header from "../../layout/Header";
// import swal from "sweetalert";
// import Card from "./Card";
// import { decrypt } from "../../../utils/encodingdecoding";


// const GiftCard = () => {
//     const [loader, setLoader] = useState(false);
//     const [data, setData] = useState([]);
//     const [isSelected, setIsSelected] = useState([]);

//     const [selectCountry, setSelectCountry] = useState({
//         options: [],
//         country: [],
//         getSearchedCountry: [],
//         allSelectCountry: "",
//         countryToggle: true,
//         searchCountryTerm: "",
//     });
//     const [groupedDatas, setGroupedData] = useState({})
//     const [categories, setCategories] = useState([]);
//     const [card, setCard] = useState({
//         getSearchedCard: [],
//         cardFlag: false,
//         allSelectCard: false,
//     });

//     const { options, country, getSearchedCountry, allSelectCountry, countryToggle, searchCountryTerm } = selectCountry;
//     const { getSearchedCard, cardFlag, allSelectCard } = card;

//     const fetchCountryRegions = async () => {
//         setLoader(true);
//         const token = JSON.parse(localStorage.getItem("token_gen"));
//         let res = await CountryRegions(token?.access_token);
//         const country = res?.map((val) => ({
//             value: val.name,
//             label: val.displayName,
//             symbol: val.isoCurrencySymbol,
//             isChecked: false,
//         }));
//         setSelectCountry({ ...selectCountry, getSearchedCountry: country.slice(0, 10), options: country });
//         // setLoader(false);
//     };

//     useLayoutEffect(() => {
//         setCategories((prev) => {
//             return prev.map((elem) => {
//                 elem.data = Array.isArray(data) && data?.filter((value) => value.category_code.split(",").includes(elem.name)).map((matchingValue) => matchingValue.id);
//                 return elem;
//             });
//         });
//     }, [data]);

//     const fetch = async (country) => {
//         let tempArr = [];
//         setLoader(true);
//         try {
//             let response = await giftCard("US");
//             setData(response.data);
//             !response?.data?.length && setLoader(false)
//             response?.data.forEach((i) => {
//                 if (Array.isArray(i.category_code.split(","))) {
//                     i.category_code.split(",").forEach((item) => {
//                         if (!tempArr.includes(item) && item) {
//                             tempArr.push({});
//                         }
//                     });
//                 }
//             });
//             let dataArr = tempArr.map((item, ind) => {
//                 return { value: "CH" + ind, name: item, data: [], isChecked: false };
//             });
//             setCategories(dataArr);
//         } catch (error) { }
//         // setLoader(false);
//     };

//     useEffect(() => {
//         const callAPI = async () => {
//             await fetchCountryRegions();
//             await fetch("selectAll");
//         };
//         callAPI();
//     }, []);

//     const fetchSelectedGiftCard = async (country) => {
//         if (country) {
//             setLoader(true);
//             try {
//                 let response = await getSelectedGiftCard(country, decrypt(localStorage.getItem("merchantcode")));
//                 setIsSelected(response?.data ? response?.data : []);
//             } catch (error) { }
//             setLoader(false);
//         }
//     };

//     useLayoutEffect(() => {
//         fetchSelectedGiftCard(country ? country : "selectAll");
//     }, []);


//     const fetchSelectGiftCard = async () => {


//         setLoader(true);
//         try {

//             let response = await getSelectGiftCard(decrypt(localStorage.getItem("merchantcode")));
//             // setIsSelected(response?.data);

//             const groupedData = {};

//             await response?.data.forEach(item => {
//                 item.countries.map((con) => {
//                     if (!groupedData[con.code]) {
//                         groupedData[con.code] = [];
//                     }
//                     groupedData[con.code].push({ name: con.name, code: con.code, data: item });
//                 })
//             });
//             const countryTemp = []

//             for (var contr in groupedData) countryTemp.push(contr)


//             setSelectCountry({
//                 ...selectCountry,
//                 country: countryTemp
//             })
//             console.log(groupedData)



//         } catch (error) {
//             console.log(error.message)
//         }
//         setLoader(false);

//     };
//     const fetchSelectGiftCard = async () => {


//         setLoader(true);
//         try {

//             let response = await getSelectGiftCard(decrypt(localStorage.getItem("merchantcode")));
//             // setIsSelected(response?.data);

//             const groupedData = {};

//             await response?.data.forEach(item => {
//                 item.countries.map((con) => {
//                     if (!groupedData[con.code]) {
//                         groupedData[con.code] = [];
//                     }
//                     groupedData[con.code].push({ name: con.name, code: con.code, data: item });
//                 })
//             });
//             const countryTemp = []

//             for (var contr in groupedData) countryTemp.push(contr)


//             setSelectCountry({
//                 ...selectCountry,
//                 country: countryTemp
//             })
//             console.log(groupedData)



//         } catch (error) {
//             console.log(error.message)
//         }
//         setLoader(false);

//     };

//     useEffect(() => {
//         fetchSelectGiftCard();
//     }, []);

//     const handleCountrySearch = (e) => {
//         let temp = [];
//         if (e.target.value) {
//             options.filter((str) => {
//                 if (str.label.toLowerCase().includes(e.target.value.toLowerCase())) {
//                     temp.push(str);
//                 }
//             });
//             setSelectCountry({ ...selectCountry, getSearchedCountry: temp, countryToggle: true, searchCountryTerm: e.target.value });
//         } else {
//             setSelectCountry({ ...selectCountry, getSearchedCountry: options, countryToggle: true, searchCountryTerm: e.target.value });
//         }
//     };

//     const handleCardSearch = (e) => {
//         let temp = [];
//         if (e.target.value) {
//             data.filter((str) => {
//                 if (str.title.toLowerCase().includes(e.target.value.toLowerCase())) {
//                     temp.push(str);
//                 }
//             });
//             setCard({ ...card, getSearchedCard: temp, cardFlag: true });
//         } else {
//             setCard({ ...card, getSearchedCard: temp, cardFlag: false });
//         }
//     };

//     const handleCountryCheckbox = (e, value) => {
//         if (value === "selectAll") {
//             e.target.value && fetchSelectedGiftCard("");
//             const allCountriesSelected = e.target.checked;
//             fetch("selectAll");
//             let temp = [];
//             if (allCountriesSelected) {
//                 temp = getSearchedCountry.map((country) => country.value);
//             }
//             setSelectCountry((prevState) => ({
//                 ...prevState,
//                 getSearchedCountry: prevState.getSearchedCountry.map((ele) => ({
//                     ...ele,
//                     isChecked: allCountriesSelected,
//                 })),
//                 allSelectCountry: allCountriesSelected ? "checked" : "",
//                 country: value,
//             }));
//         } else {
//             // e.target.value && fetchSelectedGiftCard(value);
//             fetch(e.target.checked ? value : "selectAll");
//             const updatedSearchCountry = getSearchedCountry.map((ele) => (ele.value === value ? { ...ele, isChecked: e.target.checked } : { ...ele, isChecked: false }));
//             const isSelectAllChecked = updatedSearchCountry.every((ele) => ele.isChecked);
//             let temp = [];
//             updatedSearchCountry.length &&
//                 updatedSearchCountry.map((country) => {
//                     if (country.isChecked === true) {
//                         temp.push(country.value);
//                     }
//                 });
//             setSelectCountry((prevState) => ({
//                 ...prevState,
//                 getSearchedCountry: updatedSearchCountry,
//                 allSelectCountry: isSelectAllChecked ? "checked" : "",
//                 country: e.target.checked ? value : "selectAll",
//             }));
//         }
//     };

//     useEffect(() => {
//         var length = 0;
//         categories.map((val) => val.isChecked && length++);
//         setCard((prevState) => ({
//             ...prevState,
//             allSelectCard: length === categories?.length && length !== 0 ? true : false,
//         }));
//     }, [categories]);

//     useEffect(() => {
//         const tempArr = [...categories];
//         isSelected.length &&
//             tempArr.map((values, i) => {
//                 var count = 0;
//                 values?.data?.map((val) => {
//                     isSelected.map((element) => {
//                         if (element.category === values.name && element.id === val) {
//                             count++;
//                         }
//                     });
//                 });
//                 if (values.data.length == count) {
//                     values.isChecked = true;
//                 } else {
//                     values.isChecked = false;
//                 }
//             });
//         if (isSelected.length === 0)
//             tempArr.map((values, i) => {
//                 values.isChecked = false;
//             });
//         setCategories(tempArr);
//     }, [isSelected]);

//     const handleCategory = (e, category) => {
//         if (category === "selectAll") {
//             const allCardsSelected = e.target.checked;
//             setCard((prevState) => ({
//                 ...prevState,
//                 allSelectCard: allCardsSelected ? true : false,
//             }));

//             setCategories((prev) => {
//                 prev.map((i) => {
//                     i.isChecked = allCardsSelected ? true : false;
//                 });
//                 return prev;
//             });
//             if (allCardsSelected) {
//                 let tempIsSelected = [];
//                 if (categories.length) {
//                     categories.forEach((card) => {
//                         card.data.forEach((ele) => {
//                             tempIsSelected.push({ id: ele, category: card.name });
//                         });
//                     });
//                 }
//                 setIsSelected(tempIsSelected);
//             } else {
//                 setIsSelected([]);
//             }
//         } else {
//             let tempChecked = e.target.checked;
//             let tempSelectedId = [];
//             setCategories((prevState) =>
//                 prevState.map((ele) => {
//                     if (ele.name === category) {
//                         return {
//                             ...ele,
//                             isChecked: tempChecked ? true : false,
//                         };
//                     }
//                     return ele;
//                 })
//             );

//             if (tempChecked) {
//                 let temp = isSelected.filter((ele) => {
//                     if (ele.category !== category) {
//                         return ele;
//                     }
//                 });

//                 categories.map((cat) => {
//                     if (cat.name === category) {
//                         cat.data.map((ele) => {
//                             tempSelectedId.push({ id: ele, category: cat.name });
//                         });
//                     }
//                 });
//                 setIsSelected([...temp, ...tempSelectedId]);
//             } else {
//                 isSelected.forEach((select) => {
//                     categories.forEach((cat) => {
//                         if (cat.name !== category) {
//                             cat.data.forEach((id) => {
//                                 if (select.id === id && select.category === cat.name) {
//                                     tempSelectedId.push({ id: id, category: cat.name });
//                                 }
//                             });
//                         }
//                     });
//                 });
//                 setIsSelected(tempSelectedId);
//             }
//         }
//     };

//     const handleSelect = async (id, type, category, fromSearch) => {
//         console.log(id, type, category, fromSearch)
//         let searchCat = [];
//         let newObject;
//         let index;
//         if (fromSearch) {
//             let updatedArray;
//             category.forEach((cat) => {
//                 let temp = { category: cat, id: id };
//                 index = isSelected.findIndex((item) => item.id === id && item.category === cat);
//                 if (index === -1) {
//                     searchCat.push(temp);
//                 } else {
//                     updatedArray = isSelected.filter((item) => item.id !== id);
//                 }
//             });
//             index === -1 ? setIsSelected([...isSelected, ...searchCat]) : setIsSelected(updatedArray);
//         } else {
//             newObject = { category: category, id: id };
//             index = isSelected.findIndex((item) => item.id === newObject.id && item.category === newObject.category);
//             if (index === -1) {
//                 setIsSelected([...isSelected, newObject]);
//             } else {
//                 // const con = [.../]
//                 // const groupedData = { ...groupedDatas };
//                 // //  setCountryy
//                 const updatedArray = await isSelected.filter((item) => item.id !== newObject.id || item.category !== newObject.category);
//                 const updatedArray1 = await isSelected.find((item) => item.id === newObject.id || item.category === newObject.category);
//                 console.log(updatedArray1)
//                 setSelectCountry({
//                     ...selectCountry,
//                     country: updatedArray1.countries[0].code
//                 })

//                 // updatedArray1.countries.map((cont) => {
//                 //     if (!groupedData[cont.code]) {
//                 //         groupedData[cont.code] = [];
//                 //     }
//                 //     console.log(groupedData[cont.code])
//                 //     groupedData[cont.code].push(updatedArray1);

//                 // })
//                 // setGroupedData(groupedData)


//                 // await updatedArray1.map((cate) => {

//                 //     cate.countries.map((countrie) => {
//                 //         if (!con.includes(countrie.code)) {


//                 //             // updatedArray1.forEach(item => {
//                 //             //     if (!groupedData[item.type]) {
//                 //             //         groupedData[item.type] = [];
//                 //             //     }
//                 //             //     groupedData[item.type].push(item);
//                 //             // });
//                 //             con.push(countrie.code)
//                 //         }
//                 //     })
//                 // })
//                 // setCountryy(con)
//                 setIsSelected(updatedArray);
//             }
//         }
//     };
//     console.log(groupedDatas)

//     const onSubmit = async () => {
//         let body = {};
//         let merBody = {};
//         const merchantCode = decrypt(localStorage.getItem("merchantcode"));
//         setLoader(true);
//         let temp = isSelected.map((ele) => {
//             return ele.id;
//         });
//         // if (countryy.length) {
//         //     countryy.map((con) => {
//         //         body.giftcard_code = isSelected;
//         //         body.merchant_code = merchantCode;
//         //         body.country = con;
//         //         let response = giftCardUpdate(body);
//         //         // let merchant_giftcode = [...new Set(temp)];
//         //         // merBody.merchant_code = merchantCode;
//         //         // merBody.giftcard_code = merchant_giftcode;
//         //         // merBody.country = country ? country : "selectAll";

//         //     })
//         // }

//         body.giftcard_code = isSelected;
//         body.merchant_code = merchantCode;
//         body.country = country ? country : "selectAll";


//         let merchant_giftcode = [...new Set(temp)];
//         merBody.merchant_code = merchantCode;
//         merBody.giftcard_code = merchant_giftcode;
//         merBody.country = country ? country : "selectAll";

//         let response = await giftCardUpdate(body);
//         let merResponse = await merchantGiftCard(merBody);
//         if (response?.message?.data === "Details updated successfully" && merResponse?.message?.message === "Giftcard List Updated Successfully") {
//             swal({
//                 position: "center",
//                 icon: "success",
//                 title: response?.message?.data,
//                 showConfirmButton: false,
//                 timer: 5000,
//             });
//         } else if (response?.message?.message === "Giftcard List update successfully" && merResponse?.message?.message === "Giftcard List Updated Successfully") {
//             swal({
//                 position: "center",
//                 icon: "success",
//                 title: response?.message?.message,
//                 showConfirmButton: false,
//                 timer: 5000,
//             });
//         } else {
//             swal({
//                 position: "center",
//                 icon: "error",
//                 title: response?.message?.data,
//                 showConfirmButton: false,
//                 timer: 5000,
//             });
//         }
//         setLoader(false);
//     };

//     return (
//         <>
//             <Header name={"Gift Card test"} />
//             {/* {loader && (
//                 <div className="mainPreloaderMain">
//                     <div className="mainPreloader">
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                         <div></div>
//                     </div>
//                 </div>
//             )} */}
//             <div className="dashboard__content">
//                 <div className="giftcard_mainbox">
//                     <div className="gc_sidebar">
//                         <button id="country" className="open_country_box" onClick={() => setSelectCountry((prevState) => ({ ...prevState, countryToggle: !countryToggle, searchCountryTerm: "", getSearchedCountry: options, allSelectCountry: "" }))}>
//                             <h3> Country</h3>
//                         </button>
//                         <input onChange={handleCountrySearch} type="text" placeholder="Enter Country" value={searchCountryTerm} />
//                         {countryToggle && (
//                             <div className="form-group">
//                                 {getSearchedCountry?.length ? (
//                                     <div className="select_all_countries">
//                                         <span>Select All</span>
//                                         <input type="checkbox" value={allSelectCountry ? "" : "global"} checked={allSelectCountry === "checked"} onChange={(e) => handleCountryCheckbox(e, "selectAll")} />
//                                     </div>
//                                 ) : (
//                                     ""
//                                 )}
//                                 <div className="country-select-form-box">
//                                     {getSearchedCountry?.length ? (
//                                         getSearchedCountry
//                                             .filter((ele, i) => searchCountryTerm !== "" || i < 10)
//                                             .map((ele, i) => (
//                                                 <ul key={i}>
//                                                     <li>{ele.label}</li>
//                                                     <input type="checkbox" value={ele.isChecked ? "" : ele.value} name="isChecked" checked={ele.isChecked} onChange={(e) => handleCountryCheckbox(e, ele.value)} />
//                                                 </ul>
//                                             ))
//                                     ) : (
//                                         <p>Not found</p>
//                                     )}
//                                     {!searchCountryTerm && <p>Search More Countries..........</p>}
//                                 </div>
//                             </div>
//                         )}
//                     </div>

//                     <div className="gc_contentbox">
//                         <div className="gc_content_pbox">
//                             <input type="text" id="gift_card" onChange={handleCardSearch} placeholder="Search Gift Cards/Vouchers" />
//                             {cardFlag ? (
//                                 getSearchedCard?.length ? (
//                                     <>
//                                         <div className="campaignSelection__boxes">
//                                             <div className="gc_inmainbox">
//                                                 {getSearchedCard.map(
//                                                     (value, i) =>
//                                                         Array.isArray(value.category_code.split(",")) &&
//                                                         value.category_code.length && (
//                                                             <div key={i} className="gc_innbox">
//                                                                 <Card item={value} getSearchedCountry={getSearchedCountry} handleSelect={handleSelect} isSelected={isSelected} value={value.category_code.split(",")} fromSearch={true} />
//                                                             </div>
//                                                         )
//                                                 )}
//                                             </div>
//                                         </div>
//                                         <div className="row" style={{ paddingBottom: "20px" }}>
//                                             <div className="col-sm-12  col-md-12 col-lg-12 col-xl-12">
//                                                 <div className="button-section" style={{ display: "flex", justifyContent: "flex-end" }}>
//                                                     <button type="submit" onClick={onSubmit} className="btn btn-primary" disabled={isSelected?.length < 1}>
//                                                         Update
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </>
//                                 ) : <span>Not found</span>
//                             ) : (
//                                 <div>
//                                     <div className="select_all_giftcard">
//                                         <div>Select Alls</div> <input type="checkbox" checked={allSelectCard} onChange={(e) => handleCategory(e, "selectAll")} />
//                                     </div>
//                                     <div className="accordion" id="accordionExample">
//                                         {isSelected && isSelected?.length > 0 ? (


//                                             <div className="accordion-item">

//                                                 <h2 className="accordion-header" id="staticAccordion">
//                                                     <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#staticCollapse" aria-expanded="false" aria-controls="staticCollapse">
//                                                         Selected Gift Card
//                                                     </button>
//                                                     <input type="checkbox" />
//                                                 </h2>
//                                                 <div id="staticCollapse" className="accordion-collapse collapse" aria-labelledby="staticAccordion">
//                                                     <div className="accordion-body">
//                                                         {isSelected?.length > 0 ? (
//                                                             <div className="campaignSelection__boxes">
//                                                                 <div className="gc_inmainbox">
//                                                                     {isSelected?.map((selectedItem, index) => (
//                                                                         <div key={index} className="gc_innbox">
//                                                                             <Card item={selectedItem} getSearchedCountry={getSearchedCountry} handleSelect={handleSelect} isSelected={isSelected} value={selectedItem.category} fromSearch={false} />
//                                                                         </div>
//                                                                     ))}
//                                                                 </div>
//                                                             </div>
//                                                         ) : (
//                                                             <p>No selected gift cards</p>
//                                                         )}
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             // ...

//                                         ) : (
//                                             null
//                                         )}
//                                         {console.log(categories)}
//                                         {categories &&
//                                             categories?.map((category, i) => (
//                                                 <div className="accordion-item" key={i}>
//                                                     {category.data.length > 0 && (
//                                                         <h2 className="accordion-header" id={i}>
//                                                             <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#${category.value}`} aria-expanded="false" aria-controls={category.value}>
//                                                                 {category.name + "  (" + category.data.length + ")"}
//                                                             </button>
//                                                             <input type="checkbox" name={category.value} value={category.value} checked={category.isChecked} onChange={(e) => handleCategory(e, category.name)} />
//                                                         </h2>
//                                                     )}
//                                                     <div id={category.value} className="accordion-collapse collapse" aria-labelledby={`#${i}`} data-bs-parent="#accordionExample">
//                                                         <div className="accordion-body">
//                                                             <div className="campaignSelection__boxes">
//                                                                 <div className="gc_inmainbox">
//                                                                     {data.length && data?.map(
//                                                                         (value, i) =>
//                                                                             Array.isArray(value.category_code.split(",")) &&
//                                                                             value.category_code.length &&
//                                                                             value.category_code.split(",").map(
//                                                                                 (item, i) =>
//                                                                                     item == category.name && (
//                                                                                         <div key={i} className="gc_innbox">
//                                                                                             <Card item={value} getSearchedCountry={getSearchedCountry} handleSelect={handleSelect} isSelected={isSelected} value={item} fromSearch={false} />
//                                                                                         </div>
//                                                                                     )
//                                                                             )
//                                                                     )}
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             ))}

//                                     </div>


//                                     {loader ? (
//                                         ""
//                                     ) : (
//                                         <div className="row" style={{ paddingBottom: "20px" }}>
//                                             <div className="col-sm-12  col-md-12 col-lg-12 col-xl-12">
//                                                 <div className="button-section" style={{ display: "flex", justifyContent: "flex-end" }}>
//                                                     <button type="submit" onClick={onSubmit} className="btn btn-primary" disabled={isSelected?.length < 1}>
//                                                         Update
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// };

// export default GiftCard;

import React, { useEffect, useLayoutEffect, useState } from "react";
import { giftCard, CountryRegions, giftCardUpdate, merchantGiftCard, getSelectedGiftCard, getSelectGiftCard } from "../../../actions/auth";
import Header from "../../layout/Header";
import swal from "sweetalert";
import Card from "./Card";
import { decrypt } from "../../../utils/encodingdecoding";
import { AccordionItem } from "react-bootstrap";
import { ValidatorForm } from "react-form-validator-core";
import SelectValidator from "../../partial/SelectValidator";
import { getDropdownObject } from "../../../utils/helper";


const GiftCard = () => {
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [isSelected, setIsSelected] = useState([]);
    const [globleSelected, setGlobleSelected] = useState([])

    const [selectCountry, setSelectCountry] = useState({
        options: [],
        country: "",
        getSearchedCountry: [],
        allSelectCountry: "",
        countryToggle: true,
        searchCountryTerm: "",
    });
    const [countryy, setCountryy] = useState([])
    const [option, setOption] = useState([
        {label:"",value:""}
    ])
    const [optCountry, setOptCountry] = useState("")
    const [categories, setCategories] = useState([]);
    const [categroyCOn, setCategroyCon] = useState("")
    const [catOption, setCatOption] = useState([])
    const [card, setCard] = useState({
        getSearchedCard: [],
        cardFlag: false,
        allSelectCard: false,
    });

    const { options, country, getSearchedCountry, allSelectCountry, countryToggle, searchCountryTerm } = selectCountry;
    const { getSearchedCard, cardFlag, allSelectCard } = card;




    const fetchCountryRegions = async () => {
        setLoader(true);
        const token = JSON.parse(localStorage.getItem("token_gen"));
        let res = await CountryRegions(token?.access_token);
        const country = res?.map((val) => ({
            value: val.name,
            label: val.displayName,
            symbol: val.isoCurrencySymbol,
            isChecked: false,
        }));
        setSelectCountry({ ...selectCountry, getSearchedCountry: country.slice(0, 10), options: country });
        // setLoader(false);
    };

    useLayoutEffect(() => {
        setCategories((prev) => {
            return prev.map((elem) => {
                elem.data = Array.isArray(data) && data?.filter((value) => value.category_code.split(",").includes(elem.name)).map((matchingValue) => matchingValue.id);
                return elem;
            });
        });
    }, [data]);

    const fetch = async (country) => {
        let tempArr = [];
        setLoader(true);
        try {
            let response = await giftCard(country);
            setData(response.data);
            !response?.data?.length && setLoader(false)
            response?.data.forEach((i) => {
                if (Array.isArray(i.category_code.split(","))) {
                    i.category_code.split(",").forEach((item) => {
                        if (!tempArr.includes(item) && item) {
                            tempArr.push(item);
                        }
                    });
                }
            });
            let dataArr = tempArr.map((item, ind) => {
                return { value: "CH" + ind, name: item, data: [], isChecked: false };
            });
            setCategories(dataArr);
        } catch (error) { }
        // setLoader(false);
    };

    useEffect(() => {
        const callAPI = async () => {
            await fetchCountryRegions();
            await fetch("selectAll");
        };
        callAPI();
    }, []);

    const fetchSelectedGiftCard = async (country) => {
        if (country) {
            setLoader(true);
            try {
                const tempOption = [{label:"Select",value:""}]
                let response = await getSelectedGiftCard("", decrypt(localStorage.getItem("merchantcode")));
                setGlobleSelected(response?.data ? response?.data : []);
                await response.data.map((item) => tempOption.push({ label: item.country, value: item.country }))
                setOption(tempOption)
                const uniqueCategories = [];

                // Iterate over each object in the JSON data
                response.data.forEach(obj => {
                    // Iterate over each giftcard_code in the current object
                    obj.giftcard_code.forEach(giftcard => {
                        // Check if the category already exists in the uniqueCategories array
                        if (!uniqueCategories.includes(giftcard.category)) {
                            // If it doesn't exist, push it into the array
                            uniqueCategories.push(giftcard.category);
                        }
                    });
                });
                const tempCat = [{label:"Select",value:""}]
                await uniqueCategories.map((val) =>
                    tempCat.push({ label: val, value: val })
                )


                setCatOption(tempCat)

                // Now uniqueCategories array contains all unique categories
                // console.lK/og(uniqueCategories);

            } catch (error) { }
            setLoader(false);
        }
    };

    useLayoutEffect(() => {
        fetchSelectedGiftCard(country ? country : "selectAll");
    }, [data]);


    const fetchSelectGiftCard = async () => {

        setLoader(true);
        try {
            let response = await getSelectGiftCard(decrypt(localStorage.getItem("merchantcode")));
            setIsSelected(response?.data);

        } catch (error) { }
        setLoader(false);

    };

    useEffect(() => {
        fetchSelectGiftCard();
    }, []);

    const handleCountrySearch = (e) => {
        let temp = [];
        if (e.target.value) {
            options.filter((str) => {
                if (str.label.toLowerCase().includes(e.target.value.toLowerCase())) {
                    temp.push(str);
                }
            });
            setSelectCountry({ ...selectCountry, getSearchedCountry: temp, countryToggle: true, searchCountryTerm: e.target.value });
        } else {
            setSelectCountry({ ...selectCountry, getSearchedCountry: options, countryToggle: true, searchCountryTerm: e.target.value });
        }
    };

    const handleCardSearch = (e) => {
        let temp = [];
        if (e.target.value) {
            data.filter((str) => {
                if (str.title.toLowerCase().includes(e.target.value.toLowerCase())) {
                    temp.push(str);
                }
            });
            setCard({ ...card, getSearchedCard: temp, cardFlag: true });
        } else {
            setCard({ ...card, getSearchedCard: temp, cardFlag: false });
        }
    };

    const handleCountryCheckbox = (e, value) => {
        if (value === "selectAll") {
            e.target.value && fetchSelectedGiftCard("");
            const allCountriesSelected = e.target.checked;
            fetch("selectAll");
            let temp = [];
            if (allCountriesSelected) {
                temp = getSearchedCountry.map((country) => country.value);
            }
            setSelectCountry((prevState) => ({
                ...prevState,
                getSearchedCountry: prevState.getSearchedCountry.map((ele) => ({
                    ...ele,
                    isChecked: allCountriesSelected,
                })),
                allSelectCountry: allCountriesSelected ? "checked" : "",
                country: value,
            }));
        } else {
            // e.target.value && fetchSelectedGiftCard(value);
            fetch(e.target.checked ? value : "selectAll");
            const updatedSearchCountry = getSearchedCountry.map((ele) => (ele.value === value ? { ...ele, isChecked: e.target.checked } : { ...ele, isChecked: false }));
            const isSelectAllChecked = updatedSearchCountry.every((ele) => ele.isChecked);
            let temp = [];
            updatedSearchCountry.length &&
                updatedSearchCountry.map((country) => {
                    if (country.isChecked === true) {
                        temp.push(country.value);
                    }
                });
            setSelectCountry((prevState) => ({
                ...prevState,
                getSearchedCountry: updatedSearchCountry,
                allSelectCountry: isSelectAllChecked ? "checked" : "",
                country: e.target.checked ? value : "selectAll",
            }));
        }
    };

    useEffect(() => {
        var length = 0;
        categories.map((val) => val.isChecked && length++);
        setCard((prevState) => ({
            ...prevState,
            allSelectCard: length === categories?.length && length !== 0 ? true : false,
        }));
    }, [categories]);

    useEffect(() => {
        const tempArr = [...categories];
        isSelected?.length &&
            tempArr.map((values, i) => {
                var count = 0;
                values?.data?.map((val) => {
                    isSelected.map((element) => {
                        if (element.category === values.name && element.id === val) {
                            count++;
                        }
                    });
                });
                if (values.data.length == count) {
                    values.isChecked = true;
                } else {
                    values.isChecked = false;
                }
            });
        if (isSelected?.length === 0)
            tempArr.map((values, i) => {
                values.isChecked = false;
            });
        setCategories(tempArr);
    }, [isSelected]);

    const handleCategory = (e, category) => {
        if (category === "selectAll") {
            const allCardsSelected = e.target.checked;
            setCard((prevState) => ({
                ...prevState,
                allSelectCard: allCardsSelected ? true : false,
            }));

            setCategories((prev) => {
                prev.map((i) => {
                    i.isChecked = allCardsSelected ? true : false;
                });
                return prev;
            });
            if (allCardsSelected) {
                let tempIsSelected = [];
                if (categories.length) {
                    categories.forEach((card) => {
                        card.data.forEach((ele) => {
                            tempIsSelected.push({ id: ele, category: card.name });
                        });
                    });
                }
                setIsSelected(tempIsSelected);
            } else {
                setIsSelected([]);
            }
        } else {
            let tempChecked = e.target.checked;
            let tempSelectedId = [];
            setCategories((prevState) =>
                prevState.map((ele) => {
                    if (ele.name === category) {
                        return {
                            ...ele,
                            isChecked: tempChecked ? true : false,
                        };
                    }
                    return ele;
                })
            );

            if (tempChecked) {
                let temp = isSelected.filter((ele) => {
                    if (ele.category !== category) {
                        return ele;
                    }
                });

                categories.map((cat) => {
                    if (cat.name === category) {
                        cat.data.map((ele) => {
                            tempSelectedId.push({ id: ele, category: cat.name });
                        });
                    }
                });
                setIsSelected([...temp, ...tempSelectedId]);
            } else {
                isSelected.forEach((select) => {
                    categories.forEach((cat) => {
                        if (cat.name !== category) {
                            cat.data.forEach((id) => {
                                if (select.id === id && select.category === cat.name) {
                                    tempSelectedId.push({ id: id, category: cat.name });
                                }
                            });
                        }
                    });
                });
                setIsSelected(tempSelectedId);
            }
        }
    };

    const handleSelect = async (id, type, category, fromSearch) => {
        let searchCat = [];
        let newObject;
        let index;
        if (fromSearch) {
            let updatedArray;
            category.forEach((cat) => {
                let temp = { category: cat, id: id };
                index = isSelected.findIndex((item) => item.id === id && item.category === cat);
                if (index === -1) {
                    searchCat.push(temp);
                } else {
                    updatedArray = isSelected.filter((item) => item.id !== id);
                }
            });
            index === -1 ? setIsSelected([...isSelected, ...searchCat]) : setIsSelected(updatedArray);
        } else {
            newObject = { category: category, id: id };
            index = isSelected.findIndex((item) => item.id === newObject.id && item.category === newObject.category);
            if (index === -1) {
                setIsSelected([...isSelected, newObject]);
            } else {
                const con = countryy
                const groupedData = {};
                const updatedArray = isSelected.filter((item) => item.id !== newObject.id || item.category !== newObject.category);
                const updatedArray1 = isSelected.find((item) => item.id === newObject.id || item.category === newObject.category);
                updatedArray1.countries.map((cont) => {
                    if (!groupedData[cont.code]) {
                        groupedData[cont.code] = [];
                    }
                    groupedData[cont.code].push(updatedArray1);
                    
                    if(!con.includes(cont.code))con.push(cont.code)
                    
                    
                })
                console.log("ahsan",groupedData,con)
                 setCountryy(con)
            
                setIsSelected(updatedArray);
            }
        }
    };

    const onSubmit = async () => {
        for(var i=0; i<countryy.length;i++){

        
        const tempis=await isSelected.filter((val)=>val.countries[0].code===countryy[i]).map(({ id, category }) => ({ id, category }));
        console.log(tempis)
        let body = {};
        let merBody = {};
        const merchantCode = decrypt(localStorage.getItem("merchantcode"));
        setLoader(true);
        let temp = isSelected.filter((ele) => 
             ele.countries[0].code===countryy[i] && ele.id
        ).map(({ id, category }) => ( id));
       
                body.giftcard_code = tempis;
                body.merchant_code = merchantCode;
                body.country = countryy[i];
                let response = giftCardUpdate(body);
                console.log(response)
                let merchant_giftcode = [...new Set(temp)];
                merBody.merchant_code = merchantCode;
                merBody.giftcard_code = merchant_giftcode;
                merBody.country =countryy[i]
                let merResponse = await merchantGiftCard(merBody);

            }
        

        // body.giftcard_code = isSelected;
        // body.merchant_code = merchantCode;
        // body.country = country ? country : "selectAll";
        // let response = await giftCardUpdate(body);
        // let merchant_giftcode = [...new Set(temp)];
        // merBody.merchant_code = merchantCode;
        // merBody.giftcard_code = merchant_giftcode;
        // merBody.country = country ? country : "selectAll";


        // if (response?.message?.data === "Details updated successfully" && merResponse?.message?.message === "Giftcard List Updated Successfully") {
        //     swal({
        //         position: "center",
        //         icon: "success",
        //         title: response?.message?.data,
        //         showConfirmButton: false,
        //         timer: 5000,
        //     });
        // } else if (response?.message?.message === "Giftcard List update successfully" && merResponse?.message?.message === "Giftcard List Updated Successfully") {
        //     swal({
        //         position: "center",
        //         icon: "success",
        //         title: response?.message?.message,
        //         showConfirmButton: false,
        //         timer: 5000,
        //     });
        // } else {
        //     swal({
        //         position: "center",
        //         icon: "error",
        //         title: response?.message?.data,
        //         showConfirmButton: false,
        //         timer: 5000,
        //     });
        // }
        setLoader(false);
    };

    return (
        <>
            <Header name={"Gift Card"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="giftcard_mainbox">
                    <div className="gc_sidebar">
                        <button id="country" className="open_country_box" onClick={() => setSelectCountry((prevState) => ({ ...prevState, countryToggle: !countryToggle, searchCountryTerm: "", getSearchedCountry: options, allSelectCountry: "" }))}>
                            <h3> Country</h3>
                        </button>
                        <input onChange={handleCountrySearch} type="text" placeholder="Enter Country" value={searchCountryTerm} />
                        {countryToggle && (
                            <div className="form-group">
                                {getSearchedCountry?.length ? (
                                    <div className="select_all_countries">
                                        <span>Select All</span>
                                        <input type="checkbox" value={allSelectCountry ? "" : "global"} checked={allSelectCountry === "checked"} onChange={(e) => handleCountryCheckbox(e, "selectAll")} />
                                    </div>
                                ) : (
                                    ""
                                )}
                                <div className="country-select-form-box">
                                    {getSearchedCountry?.length ? (
                                        getSearchedCountry
                                            .filter((ele, i) => searchCountryTerm !== "" || i < 10)
                                            .map((ele, i) => (
                                                <ul key={i}>
                                                    <li>{ele.label}</li>
                                                    <input type="checkbox" value={ele.isChecked ? "" : ele.value} name="isChecked" checked={ele.isChecked} onChange={(e) => handleCountryCheckbox(e, ele.value)} />
                                                </ul>
                                            ))
                                    ) : (
                                        <p>Not found</p>
                                    )}
                                    {!searchCountryTerm && <p>Search More Countries..........</p>}
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="gc_contentbox">
                        <div className="gc_content_pbox">
                            <input type="text" id="gift_card" onChange={handleCardSearch} placeholder="Search Gift Cards/Vouchers" />
                            {cardFlag ? (
                                getSearchedCard?.length ? (
                                    <>
                                        <div className="campaignSelection__boxes">
                                            <div className="gc_inmainbox">
                                                {getSearchedCard.map(
                                                    (value, i) =>
                                                        Array.isArray(value.category_code.split(",")) &&
                                                        value.category_code.length && (
                                                            <div key={i} className="gc_innbox">
                                                                <Card item={value} getSearchedCountry={getSearchedCountry} handleSelect={handleSelect} isSelected={isSelected} value={value.category_code.split(",")} fromSearch={true} />
                                                            </div>
                                                        )
                                                )}
                                            </div>
                                        </div>
                                        <div className="row" style={{ paddingBottom: "20px" }}>
                                            <div className="col-sm-12  col-md-12 col-lg-12 col-xl-12">
                                                <div className="button-section" style={{ display: "flex", justifyContent: "flex-end" }}>
                                                    <button type="submit" onClick={onSubmit} className="btn btn-primary" disabled={isSelected?.length < 1}>
                                                        Update
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <span>Not found</span>
                                )
                            ) : (
                                <div>
                                    <div className="select_all_giftcard">
                                        <div>Select All</div> <input type="checkbox" checked={allSelectCard} onChange={(e) => handleCategory(e, "selectAll")} />
                                    </div>
                                    <div className="accordion" id="accordionExample">
                                        {globleSelected && globleSelected?.length > 0 ? (
                                            <ValidatorForm>
                                                <div className="row">

                                                    <div className="accordion-item">

                                                        <h2 className="accordion-header" id="staticAccordion">
                                                            <div className="col-md-4">
                                                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#staticCollapse" aria-expanded="false" aria-controls="staticCollapse">
                                                                Selected Gift Card
                                                            </button>
                                                            </div>

                                                            {/* optCountry, setOptCountry */}
                                                            <div className="col-md-3">

                                                                <SelectValidator options={option} value={getDropdownObject(optCountry, option)} onChange={(e) => setOptCountry(e.value)} />
                                                            </div>
                                                            <div className="col-md-3">

                                                                <SelectValidator options={catOption} value={getDropdownObject(categroyCOn, catOption)} onChange={(e) => setCategroyCon(e.value)} />
                                                            </div>

                                                            {/* <input type="checkbox" /> */}
                                                        </h2>
                                                        <div id="staticCollapse" className="accordion-collapse collapse" aria-labelledby="staticAccordion">
                                                            <div className="accordion-body">
                                                                {isSelected?.length > 0 ? (
                                                                    <div className="campaignSelection__boxes">
                                                                        <div className="gc_inmainbox">
                                                                            {isSelected?.length && isSelected.map((item,index) => (
                                                                                   (item.countries[0].code==optCountry||optCountry=="") &&(categroyCOn==""||item.category_code==categroyCOn ) &&<div key={index} className="gc_innbox">
                                                                                        <Card item={item} getSearchedCountry={getSearchedCountry} handleSelect={handleSelect} isSelected={isSelected} value={item.category} fromSearch={false} />
                                                                                    </div>

                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <p>No selected gift cards</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ValidatorForm>
                                            // ...

                                        ) : (
                                            null
                                        )}

                                        {categories &&
                                            categories?.map((category, i) => (
                                                <div className="accordion-item" key={i}>
                                                    {category.data.length > 0 && (
                                                        <h2 className="accordion-header" id={i}>
                                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#${category.value}`} aria-expanded="false" aria-controls={category.value}>
                                                                {category.name + "  (" + category.data.length + ")"}
                                                            </button>
                                                            <input type="checkbox" name={category.value} value={category.value} checked={category.isChecked} onChange={(e) => handleCategory(e, category.name)} />
                                                        </h2>
                                                    )}
                                                    <div id={category.value} className="accordion-collapse collapse" aria-labelledby={`#${i}`} data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <div className="campaignSelection__boxes">
                                                                <div className="gc_inmainbox">
                                                                    {data.length && data?.map(
                                                                        (value, i) =>
                                                                            Array.isArray(value.category_code.split(",")) &&
                                                                            value.category_code.length &&
                                                                            value.category_code.split(",").map(
                                                                                (item, i) =>
                                                                                    item == category.name && (
                                                                                        <div key={i} className="gc_innbox">
                                                                                            <Card item={value} getSearchedCountry={getSearchedCountry} handleSelect={handleSelect} isSelected={isSelected} value={item} fromSearch={false} />
                                                                                        </div>
                                                                                    )
                                                                            )
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                    {loader ? (
                                        ""
                                    ) : (
                                        <div className="row" style={{ paddingBottom: "20px" }}>
                                            <div className="col-sm-12  col-md-12 col-lg-12 col-xl-12">
                                                <div className="button-section" style={{ display: "flex", justifyContent: "flex-end" }}>
                                                    <button type="submit" onClick={onSubmit} className="btn btn-primary" disabled={isSelected?.length < 1}>
                                                        Update
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GiftCard;

